export const range = (
  ...args: [number, number, number] | [number, number] | [number]
) => {
  if (args.length === 1) {
    return Array.from(
      { length: Math.abs(args[0]) },
      (_, i) => i * Math.sign(args[0]),
    );
  }
  if (args.length === 2) {
    return Array.from(
      { length: Math.abs(args[1] - args[0]) },
      (_, i) => i + args[0],
    );
  }
  if (args[2] === 0) {
    return Array.from(
      { length: args[1] - args[0] },
      (_, i) => args[0] + i * args[2],
    );
  }
  return Array.from(
    { length: (args[1] - args[0]) / args[2] },
    (_, i) => args[0] + i * args[2],
  );
};
